import React, { useContext, useEffect, useState } from 'react'
import { CertificateOutletType } from '..'
import { useNavigate, useOutletContext } from 'react-router-dom'
import { GlobalTable, HeaderLine, Td, TdButtons, Th, Tr, FooterTr } from '../../../../components/styles/table-style'
import LoadMoreButton from '../../../../components/LoadMoreButton'
import axios from '../../../../config/axios'
import { ParamType } from '../CreateParam'
import editPen from '../../../../assets/certificates/Tables/pencil.svg'

const ParamTable = () => {
  const [ parameters, setParameters ] = useState<ParamType[]>([])
  const [ filteredParameters, setFilteredParameters ] = useState<ParamType[]>([])
  const [ visibleCount, setVisibleCount ] = useState<number>(10)
  const { setTabIndex, appliedFilters, search } = useOutletContext<CertificateOutletType>()
  const navigate = useNavigate()
  
  useEffect(() => {
    setTabIndex(1)
  }, [])
  
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/certificates/param`)
      .then(response => {
        if(response.data) {
          setParameters(response.data)
          setFilteredParameters(response.data)
        }
      })
      .catch(error => {
        console.error(error)
      })
  }, [])

  useEffect(() => {
    let filtered = [...parameters]

    if (search && search.trim()) {
      filtered = filtered.filter(param =>
        param.name?.toLowerCase().includes(search.toLowerCase()) ||
        param.class?.toLowerCase().includes(search.toLowerCase()) ||
        param.family?.toLowerCase().includes(search.toLowerCase()) ||
        param.astm?.toLowerCase().includes(search.toLowerCase()) ||
        param.uns?.toLowerCase().includes(search.toLowerCase()) ||
        param.din?.toLowerCase().includes(search.toLowerCase()) ||
        param.aisi?.toLowerCase().includes(search.toLowerCase()) ||
        param.others?.toLowerCase().includes(search.toLowerCase())
      )
    }

    appliedFilters.forEach(filter => {
      if (filter.value && filter.value.trim()) {
        filtered = filtered.filter(param => {
          const fieldValue = param[filter.key as keyof ParamType]
          return fieldValue?.toString().toLowerCase().includes(filter.value.toLowerCase())
        })
      }
    })

    setFilteredParameters(filtered)
  }, [parameters, appliedFilters, search])
  
  return (
    <>
      <GlobalTable>
        <thead>
          <HeaderLine>
            <Th>Nome do parâmetro</Th>
            <Th>Classe</Th>
            <Th>Família</Th>
            <Th>ASTM</Th>
            <Th>UNS</Th>
            <Th>DIN</Th>
            <Th>AISI</Th>
            <Th>Outros</Th>
            <Th></Th>
          </HeaderLine>
        </thead>
        <tbody>
          {filteredParameters.slice(0, visibleCount).map((param, index) => 
            <Tr key={index}>
              <Td>{param.name}</Td>
              <Td>{param.class}</Td>
              <Td>{param.family}</Td>
              <Td>{param.astm}</Td>
              <Td>{param.uns}</Td>
              <Td>{param.din}</Td>
              <Td>{param.aisi}</Td>
              <Td>{param.others}</Td>
              <TdButtons>
                <img src={editPen} alt='edit-icon' onClick={() => navigate(`edit/?id=${param.id}`)} />
              </TdButtons>
            </Tr>
          )}
        </tbody>
        <tfoot>
          <FooterTr>
            <Td colSpan={9} style={{ textAlign: 'center', background: 'transparent' }}>
              <LoadMoreButton
                currentCount={Math.min(visibleCount, filteredParameters.length)}
                totalCount={filteredParameters.length}
                onLoadMore={() => setVisibleCount(prev => prev + 10)}
                hasMore={visibleCount < filteredParameters.length}
              />
            </Td>
          </FooterTr>
        </tfoot>
      </GlobalTable>
    </>
  )
}

export default ParamTable